import { SearchWidget } from '@organisms/SearchWidget';

import { OrgDropDown } from './OrgDropDown';

export const GlobalFilters = () => {
  return (
    <div className="flex w-full justify-between gap-2">
      <SearchWidget />
      <OrgDropDown />
    </div>
  );
};
